import React from 'react';
import {
  withRouter,
} from 'react-router-dom'
import auth from '../auth/auth.react.js';
import Cookies from 'js-cookie';
import Hidden from 'material-ui-next/Hidden';
import Button from 'material-ui-next/Button';
import { withStyles } from 'material-ui-next/styles';
import LogoutIcon from '../assets/icons/logoutIcon.react.js';
import LoginIcon from '../assets/icons/loginIcon.react.js';

const colorMain = '#3ED5AD'
const colorHighlight = '#979797'
const styles = theme => ({
  button: {
    marginLeft: 10,
    backgroundColor: colorMain,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: colorHighlight,
    }
  },
  icon: {
    marginRight: 5,
    color: theme.palette.common.white
  },
})

class _AuthButton extends React.Component {
  render() {
    const {
      history,
      classes
    } = this.props;
    if (auth.isAuthenticated()) {
      const usercache = Cookies.getJSON('usercache') || {
        first_name: 'no-name',
        last_name: 'unknown'
      }
      return (
        <div styleName="nav-bar-user-text">
          <Hidden smDown>
            <span>Welcome {usercache.username}</span>
          </Hidden>
          <Button
            onClick={() => {
                auth.signout(() => history.push('/'))
            }}
            variant="flat"
            className={classes.button}
            color="primary">
            <LogoutIcon className={classes.icon} />
            LOGOUT
          </Button>
        </div>
      )
    }
    return (
      <Button
        onClick={() => {
            auth.signout(() => history.push('/login'))
        }}
        className={classes.button}
        variant="flat"
        color="primary">
        <LoginIcon className={classes.icon} />
        LOGIN
      </Button>
    )
  }
}

const AuthButton = withRouter(withStyles(styles)(_AuthButton));

export default AuthButton



// WEBPACK FOOTER //
// ./src/widgets/auth_button.react.js